<template>
    <div class="login-container">
        <div class="container">
            <div class="row">
                <div class="col-md-8 d-flex align-items-center">
                    <div class="content-box">
                        <div class="row">
                        <div class="col-12">
                            <h4 class="display-4">Ainda não sou cadastrado.</h4>
                            <p>Realize seu cadastro e tenha acesso a descontos em consultas ou exames médicos</p>
                        </div>
                        <p><router-link tag="a" :to="{name: 'Cadastrese-pergunta'}" class="btn btn-lg btn-primary button-big">Fazer o cadastro</router-link></p>
                    </div>
                    <div class="row">
                       <div class="col">
                            
                       </div>
                    </div>
                    </div>
                </div>
                <div class="col">
                    <div class="auth-box-w">
                        <h4 class="auth-header">
                        Login Cliente
                        </h4>
                        <form @submit.prevent="auth()">
                        <div v-if="msgErro" class="alert alert-danger">
                            {{msgErro}}
                        </div>
                        <div class="form-group">
                            <label for="">Usuário</label>
                            <input required v-model="credentials.username" class="form-control" placeholder="Digite seu usuário" type="text">
                            <div class="pre-icon os-icon os-icon-user-male-circle"></div>
                        </div>
                        <div class="form-group">
                            <label for="">Senha</label>
                            <input required v-model="credentials.password" class="form-control" placeholder="Digite sua senha" type="password">
                            <div class="pre-icon os-icon os-icon-fingerprint"></div>
                        </div>
                        <div class="buttons-w">
                            <button class="btn btn-primary">
                            Entrar
                            </button>
                            
                            <div class="form-check-inline">
                            <label class="form-check-label"><input class="form-check-input" type="checkbox">Manter conectado</label>
                            </div>
                        </div>
                        </form>
                    
                    </div>
                </div>
            </div>
        </div>
        
    </div>
    
</template>
<script>
export default {
  created () {
    console.log('Created', this.credentials)
  },
  data () {
    return {
      msgErro: null,
      credentials: {
        username: '',
        password: ''
      }
    }
  },
  methods: {
    isValid () {
      return true
    },
    auth () {
      if (this.isValid()) {
        var payload = {
          username: this.credentials.username,
          password: this.credentials.password
        }
        this.$store.dispatch('login', payload)
          .then((user) => {
            this.msgErro = null
            this.$router.push({name: 'HomeAdmin'})
          })
          .catch(error => {
            console.log(error)
            this.msgErro = error.message
          })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/LoginCliente.vue